import { RadioGroup } from '@atlaskit/radio';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import type { AnalyticsTrackType } from '../../../../../model/wac-signup-form';
import { InfoBox } from './info-box';

import { Label, RadioGroupWrapper } from './styled';

export type GdprLocationProps = {
  onLocationChange: (gdprLocation: string | null) => void;
  analyticsTrack: AnalyticsTrackType;
};
const gdprData = [
  { name: 'gdprDataUS', value: 'US', label: 'US' },
  { name: 'gdprDataEU', value: 'EU', label: 'EU' }
];

export function GdprLocation({
  onLocationChange,
  analyticsTrack
}: GdprLocationProps) {
  const { segment } = analyticsTrack;

  return (
    <>
      <Label>
        <FormattedMessage {...messages.gdprMessage} />
      </Label>
      <RadioGroupWrapper>
        <RadioGroup
          options={gdprData}
          defaultValue={'US'}
          onChange={(event) => {
            segment('wac-signup-gdpr-selected', { value: event.target.value });
            onLocationChange(event.target.value);
          }}
        />
      </RadioGroupWrapper>
      <InfoBox fontSize={'14px'}>
        <SanitizedFormattedHtmlMessage
          {...messages.opsgenieDataStorageInfoBoxCopy}
        />
      </InfoBox>
    </>
  );
}
